import { createContext, PropsWithChildren, useContext } from 'react';
import { useExhibitExporterProvider } from './useExhibitExporterProvider';

type ProviderData = ReturnType<typeof useExhibitExporterProvider>;
const ExhibitExporterContext = createContext<ProviderData>({} as ProviderData);

export const ExhibitExporterProvider = ({ children }: PropsWithChildren<{}>) => {
  const value = useExhibitExporterProvider();
  return (
    <ExhibitExporterContext.Provider value={value}>
      {children}
    </ExhibitExporterContext.Provider>
  );
};

export const useExhibitExporterContext = () => useContext(ExhibitExporterContext);
